$(() => {
  $('[data-scroll-to-bottom]').each(function () {
    this.scrollTop = this.scrollHeight;
  });
});
